/**
 * Definition for types of references
 */
export var REFERENCE_TYPE;
(function (REFERENCE_TYPE) {
  REFERENCE_TYPE["TASK"] = "TASK";
  REFERENCE_TYPE["BUG"] = "BUG";
  REFERENCE_TYPE["ALARM"] = "ALARM";
  REFERENCE_TYPE["DEVICE"] = "DEVICE";
  REFERENCE_TYPE["SITE"] = "SITE";
  REFERENCE_TYPE["PERSON"] = "PERSON";
  REFERENCE_TYPE["EXTERNAL"] = "EXTERNAL";
  REFERENCE_TYPE["CONDUIT"] = "CONDUIT";
  REFERENCE_TYPE["HANDHOLE"] = "HANDHOLE";
  REFERENCE_TYPE["FIBER"] = "FIBER";
  REFERENCE_TYPE["CUSTOMER"] = "CUSTOMER";
  REFERENCE_TYPE["ASSET"] = "ASSET";
  REFERENCE_TYPE["SPLICE"] = "SPLICE";
  REFERENCE_TYPE["PAYMENT"] = "PAYMENT";
  REFERENCE_TYPE["INVOICE"] = "INVOICE";
  REFERENCE_TYPE["SUBSCRIPTION"] = "SUBSCRIPTION";
})(REFERENCE_TYPE || (REFERENCE_TYPE = {}));